import React, { useState, useCallback } from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import ReactPlayer from 'react-player';

import Forms from '../../components/Forms';
import { formatPhoneBr } from '../../hooks/formatPhoneBr';
import axios from '../../services/axios';
import ErrorProcessor from '../../components/ErrorProcessor';
import { useNotification } from '../../components/Notification/NotificationContext';
import Loading from '../../components/Loading';

export default function LeadIvrOpenNewCanceled({ lead, updateLeadData }) {
  const [formValues, setFormValues] = useState(lead);
  const [isLoading, setIsLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState({});
  const notification = useNotification();

  const validationSchema = Yup.object().shape({});

  const handleFieldChange = useCallback((fieldName, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      LeadIvrOpenNewCanceled: {
        ...prevValues.LeadIvrOpenNewCanceled,
        [fieldName]: value,
      },
    }));
  }, []);

  const fields = [
    {
      name: 'metodo_reembolso',
      id: 'metodo_reembolso',
      label: 'Método de reembolso',
      type: 'text',
      onChange: (e) => handleFieldChange('metodo_reembolso', e.target.value),
      colSize: 4,
      additionalProps: {},
    },
    {
      name: 'banco',
      id: 'banco',
      label: 'Banco',
      type: 'text',
      onChange: (e) => handleFieldChange('banco', e.target.value),
      colSize: 4,
      additionalProps: {},
    },
    {
      name: 'conta',
      id: 'conta',
      label: 'Conta',
      type: 'text',
      onChange: (e) => handleFieldChange('conta', e.target.value),
      colSize: 4,
      additionalProps: {},
    },
    {
      name: 'titular_conta',
      id: 'titular_conta',
      label: 'Titular da conta',
      type: 'text',
      onChange: (e) => handleFieldChange('titular_conta', e.target.value),
      colSize: 4,
      additionalProps: {},
    },
    {
      name: 'pix',
      id: 'pix',
      label: 'Pix',
      type: 'text',
      onChange: (e) => handleFieldChange('pix', e.target.value),
      colSize: 4,
      additionalProps: {},
    },
  ];

  const getLead = useCallback(async () => {
    try {
      const request = await axios.get(`leads/${formValues.id}`);
      setFormValues({
        ...request.data,
      });
    } catch (err) {
      setApiErrors(err);
    }
  }, [formValues]);

  const handleSubmit = async () => {
    try {
      const dataForm = {
        pix: formValues.LeadIvrOpenNewCanceled.pix,
        metodo_reembolso: formValues.LeadIvrOpenNewCanceled.metodo_reembolso,
        conta: formValues.LeadIvrOpenNewCanceled.conta,
        titular_conta: formValues.LeadIvrOpenNewCanceled.titular_conta,
        banco: formValues.LeadIvrOpenNewCanceled.banco,
      };
      setIsLoading(true);
      await axios.put(
        `leadsivropennewcancel/${formValues.LeadIvrOpenNewCanceled.id}`,
        dataForm
      );
      notification(`Lead atualizado com sucesso`, 'success');
      getLead();
      updateLeadData();
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="mb-5">
      <Loading isLoading={isLoading} />
      <ErrorProcessor error={apiErrors} />
      <Card.Header>
        <h4 className="card-heading">Informações da fonte de lead</h4>
      </Card.Header>
      <Card.Body>
        <Row className="mb-3">
          <Col>
            <Form.Label>Tipo</Form.Label>
            <h6 className="mb-3">
              {formValues.LeadIvrOpenNewCanceled.tipo || 'Não identificado'}
            </h6>
          </Col>
          <Col>
            <Form.Label>Duração da chamada</Form.Label>
            <h6 className="mb-3">
              {formValues.LeadIvrOpenNewCanceled.call_time}
            </h6>
          </Col>
          <Col>
            <Form.Label>Número do telefone</Form.Label>
            <h6 className="mb-3">
              {formatPhoneBr(formValues.LeadIvrOpenNewCanceled.phone)}
            </h6>
          </Col>
          <Col>
            <Form.Label>Gravação da chamada</Form.Label>
            <ReactPlayer
              url={formValues.LeadIvrOpenNewCanceled.record_url}
              controls
              width="100%"
              height={40}
            />
          </Col>
        </Row>
        <hr className="bg-gray-400 my-4" />
        <Forms
          initialValues={formValues.LeadIvrOpenNewCanceled}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          fields={fields}
          btnSubmit={{
            variant: 'primary',
            type: 'submit',
            text: 'Atualizar',
          }}
        />
      </Card.Body>
    </Card>
  );
}

LeadIvrOpenNewCanceled.defaultProps = {
  updateLeadData: () => {},
};

LeadIvrOpenNewCanceled.propTypes = {
  lead: PropTypes.shape({
    LeadIvrOpenNewCanceled: PropTypes.shape({}),
    id: PropTypes.number,
  }).isRequired,
  updateLeadData: PropTypes.func,
};
